import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    CartesianGrid,
} from "recharts";

const MainChart = ({ data }: { data: any[] }) => {
    return (
        <div className="bg-white p-5 rounded-2xl shadow-sm">
            <h2 className="text-lg font-semibold mb-4">Sales Overview</h2>

            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Line type="monotone" dataKey="sales" stroke="#3b82f6" strokeWidth={3} />
                    <Line type="monotone" dataKey="outstanding" stroke="#ef4444" />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default MainChart;